/**
 * TableSorter  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { getBaseClass } from "./baseClass";
import { TABLE_SORT } from "./TableTypes";
import { Icon, ICON_SIZE } from "../Icon";

export interface ITableSorterProps {
	active?: boolean;
	direction?: TABLE_SORT;
}

export const TableSorter: React.FC<ITableSorterProps> = ({ active, direction }) => {
	const baseClass = getBaseClass("sorter", {
		active,
		direction
	});

	return <Icon className={baseClass.toClassName()} name="mdi/arrow-down" size={ICON_SIZE.XSMALL} />;
};
